import React, { useEffect, useState } from 'react';
import PdfSingle from '../PdfSingle';
import { getCiegDocuments, normalizeCiegDocument } from '../../../services/ciegDocumentsService';

const CiegSingleDocumentPage = ({ title, categoryPath }) => {
    const [document, setDocument] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;

        setLoading(true);
        getCiegDocuments(categoryPath)
            .then((data) => {
                if (mounted) {
                    const documents = data.map(normalizeCiegDocument);
                    setDocument(documents.length > 0 ? documents[0] : null);
                }
            })
            .catch((error) => {
                console.log(error);
                if (mounted) {
                    setDocument(null);
                }
            })
            .finally(() => {
                if (mounted) {
                    setLoading(false);
                }
            });

        return () => {
            mounted = false;
        };
    }, [categoryPath]);

    if (loading) {
        return (
            <div className='container'>
                <br />
                <div className='row'>
                    <div className='col-lg-12 text-center'>
                        <p>Cargando...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!document) {
        return (
            <div className='container'>
                <br />
                <div className='row'>
                    <div className='col-lg-12 text-center'>
                        <h2>{title}</h2>
                        <p>No hay archivo disponible.</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <PdfSingle file={document.file} title={document.title || title} />
    );
};

export default CiegSingleDocumentPage;
